import React, { useEffect } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router';
import { REST_HOST } from '../../../../../env.config';
import { useLocale } from '../../../../../i18n';
import useBrokerId from '../../../../common/src/hooks/query-params/useBrokerId';
import useTracking from '../../../../common/src/hooks/tracking/useTracking';
import useQueryParams from '../../../../common/src/hooks/useQueryParams';
import { request } from '../../../../common/src/legacy/services/httpSessionService';
import AdvisoryFlowLoading from '../../../../flows/src/components/ui/advisory-flow/components/app-shell/AdvisoryFlowLoading';
import CompanyScanLoading from '../../../../flows/src/components/ui/company-scan/components/app-shell/CompanyScanLoading';
import useSessionId from '../../../../flows/src/hooks/useSessionId';
import useRiskAnalysisType from '../../hooks/useRiskAnalysisType';

const Finalize: React.FC<React.PropsWithChildren<unknown>> = () => {
  const sessionId = useSessionId();
  const riskAnalysisType = useRiskAnalysisType();
  const { trackEvent } = useTracking();

  const history = useHistory();
  const QueryClient = useQueryClient();
  const { userLang, userCountry } = useLocale();
  const brokerId = useBrokerId();
  const lang = useQueryParams().get('lang');

  const { mutate: createRecommendations } = useMutation(
    () => {
      return request({
        path: `/v1/api/insurance-recommendations?lang=${userLang}&country=${userCountry}`,
        method: 'POST',
        origin: REST_HOST,
        payload: {
          conversation_id: sessionId,
          products_version: 'V2',
        },
      });
    },
    {
      onSuccess: (data) => {
        const [resp, status] = data;
        if (riskAnalysisType !== 'company-scan')
          trackEvent('Get Recommendation in Risk Analysis');

        if (status <= 201) {
          QueryClient.setQueryData(
            [sessionId, 'recommendation', resp.id],
            resp,
          );
          history.replace(
            riskAnalysisType === 'company-scan'
              ? brokerId
                ? `/risk-analysis/recommendations/${resp.id}?session_id=${sessionId}&broker_id=${brokerId}&type=company-scan&lang=${lang}`
                : `/risk-analysis/recommendations/${resp.id}?session_id=${sessionId}&type=company-scan`
              : `/risk-analysis/recommendations/${resp.id}?session_id=${sessionId}`,
          );
        } else {
          history.replace(
            riskAnalysisType === 'company-scan'
              ? brokerId
                ? `/risk-analysis/recommendations?session_id=${sessionId}&broker_id=${brokerId}&type=company-scan&lang=${lang}`
                : `/risk-analysis/recommendations?session_id=${sessionId}&type=company-scan`
              : `/risk-analysis/recommendations?session_id=${sessionId}`,
          );
        }
      },
      onError: () => {
        history.replace(
          riskAnalysisType === 'company-scan'
            ? brokerId
              ? `/risk-analysis/recommendations?session_id=${sessionId}&broker_id=${brokerId}&type=company-scan&lang=${lang}`
              : `/risk-analysis/recommendations?session_id=${sessionId}&type=company-scan`
            : `/risk-analysis/recommendations?session_id=${sessionId}`,
        );
      },
    },
  );

  useEffect(() => {
    createRecommendations();
  }, []);

  return riskAnalysisType === 'company-scan' ? (
    <CompanyScanLoading />
  ) : (
    <AdvisoryFlowLoading />
  );
};

export default Finalize;
